import React from 'react';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import TextInput from '../fields/TextInput';
import Heading from '../elements/PageHeading';

const DeviceIdPage = ({ t }) => (
  <React.Fragment>
    <Heading text={t('device_id.title')} />
    <form>
      <Field name="Id" type="text" component={TextInput} />
    </form>
  </React.Fragment>
);

export default translate()(DeviceIdPage);
